var SyncedSlider = function () {

	this.init = function () {

		$('[data-component="synced-slider"] .text-slick').slick({
			dots: false,
			arrows: false,
			slidesToShow: 1,
			infinite: true,
			asNavFor: '.content-slick',
			adaptiveHeight: true,
			speed: 600,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						infinite: false
					}
				}
			]
		})

		$('[data-component="synced-slider"] .content-slick').each(function() {
			if($(this).prev('.text-slick').hasClass('static-slider')) {
				$(this).slick({
					dots: false,
					arrows: true,
					slidesToShow: 3,
					variableWidth: true,
					infinite: true,
					focusOnSelect: true,
					centerMode: true,
					speed: 600,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								variableWidth: false,
								centerPadding: '0'
							}
						},
						{
							breakpoint: 768,
							settings: {
								dots: true,
								arrows: false,
								slidesToShow: 1,
								variableWidth: false,
								centerPadding: '0',
								infinite: false
							}
						}
					]
				});
			} else {
				$(this).slick({
					dots: false,
					arrows: true,
					slidesToShow: 3,
					variableWidth: true,
					infinite: true,
					focusOnSelect: true,
					centerMode: true,
					speed: 600,
					asNavFor: '.synced-slider',
					responsive: [
						{
							breakpoint: 992,
							settings: {
								variableWidth: false,
								centerPadding: '0'
							}
						},
						{
							breakpoint: 768,
							settings: {
								dots: true,
								arrows: false,
								slidesToShow: 1,
								variableWidth: false,
								centerPadding: '0',
								infinite: false
							}
						}
					]
				});
			}
		})
	}

	return this.init();
}
